<template>
  <div class="row justify-content-center">
    <div class="col-sm-9 col-md-8 col-lg-6 col-xl-4">
      <form>
        <div class="form-group">
          <label for="categoryName">{{ $t("forms.name.label") }}</label>
          <input
            :class="['form-control', valid.name ? 'is-valid' : 'is-invalid']"
            id="categoryName"
            aria-describedby="categoryNameHelp"
            :placeholder="$t('forms.name.placeholder')"
            v-model="category.name"
            @input="validateLength('name')"
          />
          <small id="categoryNameHelp" class="form-text text-muted"></small>
        </div>
        <div class="form-group">
          <label for="categoryColor">{{ $t("forms.color.label") }}</label>
          <slider-picker
            class="mb-3"
            v-model="colorPicker"
            @input="pickerUpdated"
          />
          <input
            :class="['form-control', valid.color ? 'is-valid' : 'is-invalid']"
            id="categoryColor"
            aria-describedby="categoryColorHelp"
            :placeholder="$t('forms.color.placeholder')"
            v-model="category.color"
            @input="colorInputUpdated($event.target.value)"
          />
          <small id="categoryColorHelp" class="form-text text-muted">
            {{ $t("forms.color.helper") }}
          </small>
        </div>
        <div class="d-flex justify-content-center">
          <button
            type="submit"
            class="btn btn-success"
            :disabled="!validForm"
            :aria-disabled="!validForm"
            @click.prevent="submit"
          >
            {{ $t(id ? "buttons.save" : "buttons.create") }}
          </button>
          <div class="btn btn-danger ml-3" @click="$router.go(-1)">
            {{ $t("buttons.cancel") }}
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Slider } from "vue-color";
import { randomKey } from "./../../tools";

export default {
  name: "CategoryForm",
  components: {
    "slider-picker": Slider
  },
  props: {
    id: { type: String, default: null },
    category: {
      type: Object,
      default() {
        return { name: "", color: "" };
      }
    }
  },
  data() {
    return {
      colorPicker: "",
      valid: {
        name: false,
        color: false
      }
    };
  },
  computed: {
    ...mapGetters(["pantryAuthData"]),
    validForm() {
      for (let property in this.valid) {
        if (!this.valid[property]) {
          return false;
        }
      }
      return true;
    }
  },
  watch: {
    category(newcategory, oldcategory) {
      // in case categories are being fetched asynchronously from remote
      this.changeBackground();
    }
  },
  methods: {
    validateLength(name) {
      this.valid[name] =
        this.category.hasOwnProperty(name) && !!this.category[name].length;
    },
    validateColor() {
      this.valid.color =
        this.category.hasOwnProperty("color") &&
        !!this.category.color.match(/^[0-9a-fA-F]{6}$/g);
      if (this.valid.color) {
        this.$store.commit("changeBg", this.category.color);
      }
    },
    pickerUpdated(color) {
      this.category.color = color.hex.substr(1);
      this.validateColor();
    },
    colorInputUpdated(color) {
      this.colorPicker = "#" + color;
      this.validateColor();
    },
    submit() {
      if (this.validForm) {
        const now = new Date().getTime();
        this.category.created = this.category.created
          ? this.category.created
          : now;
        this.category.updated = now;
        const curr_id = this.id ? this.id : randomKey();
        // TODO: show loading?
        this.$store.state.resources.categories
          .update(
            {
              ...this.pantryAuthData,
              id: curr_id
            },
            this.category
          )
          .then(
            /*response*/ () => {
              this.$emit("categorySubmitted", {
                id: curr_id,
                category: this.category
              });
              // console.log(response.body.name);
            },
            error => {
              console.log(error);
            }
          );
      }
    },
    changeBackground() {
      this.$store.commit("changeBg", this.category.color);
    }
  },
  created() {
    this.validateLength("name");
    this.colorInputUpdated(this.category.color);
    this.changeBackground();
  }
};
</script>

<style scoped>
.vc-slider {
  width: 100%;
}
</style>
